<template>
  <svg
    width="31"
    height="32"
    viewBox="0 0 31 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="14.8964"
      cy="15.3974"
      r="4.82222"
      stroke="black"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.9248 21.4248L18.3027 18.8027"
      stroke="black"
      stroke-width="0.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {};
</script>
